/**
 * @module Section-Home2-FAQ
 */

import { TypeSectionFAQ } from "../../../@types/sectionTypes";
import AvertImage from "../../../../globals/elements/avertimg";
   import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
import { useRef } from "react";
gsap.registerPlugin(ScrollTrigger, SplitText);
/**
 * 
 * @param props : Data supplied to display FAQ
 * @returns Section with frequently asked questions
 */
const SectionHome2FAQ = (
    props: {
        _faqs: TypeSectionFAQ
    }
) => {
    const { _faqs } = props;
     const container = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
    //   let split = SplitText.create(".about_para_animation", {
    //     type: "lines",
    //   });
 
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
        //   markers: true
        },
      });
    //   tl.fromTo(
    //     ".reveal",
    //     { scale: 0.8, opacity: 0 },
    //     { scale: 1, duration: 1, opacity: 1 },
    //   )

tl.fromTo(
          ".whyus_heading_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
          }, "0"
        ).fromTo(
          ".whyus_image_animation",
          { opacity: 0, y: 100 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
          }, "0"
        )
        .fromTo(
          ".about_para_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0.4"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
    return (
        <div className="section-full p-b90 site-bg-white av-FAQ-section-wrap wow fadeInDown" data-wow-offset={100} data-wow-delay="0.2">
            <div className="container">
                <div className="section-content" ref={container}>
                    <div className="row">
                        <div className="col-lg-7 col-md-12 m-b30">
                            <div className="av-faq-info-wrap">
                                <div className="av-content-title">
                                    <h2 className="av-large-title2 whyus_heading_animation">{_faqs.title}</h2>
                                    <p className="p-text about_para_animation">{_faqs.subtitle}</p>
                                </div>
                                <div className="av-faq-info">
                                    <div className="accordion av-acdn" id="sf-faq-accordion">
                                        {
                                            _faqs.faqs.map((_item, _index) => {
                                                return (
                                                    <div key={_index} className="accordion-item about_para_animation">
                                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#FAQ"+_index} aria-expanded="false">
                                                            {_item.que}
                                                        </button>
                                                        <div id={"FAQ"+_index} className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion">
                                                            <div className="accordion-body">
                                                                {_item.ans}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12 m-b30 sticky-sidebar">
                            <div className="av-faq-media">
                                <div className="av-media-1 whyus_image_animation">
                                    <AvertImage src={_faqs.image} alt="#" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SectionHome2FAQ;